import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { updateProps, updatePost } from '../../../stores/newsfeed/actions';
import { Avatar, FlatButton } from 'material-ui';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

const NewComment = props => {
  const {
    profileImageUrl,
    companyName,
    userEnteredComment,
    companyId,
    userId,
    userFirstName,
    userLastName,
    userEmail,
    updatingPost,
    commentPostId,
    updateProp,
    postId,
    updateAPost,
  } = props;

  const autoExpand = () => {
    document.getElementById('newCommentArea').style.height = '5px';
    document.getElementById('newCommentArea').style.height = `${document.getElementById('newCommentArea').scrollHeight}px`;
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
        <div style={{ marginTop: '5px' }}>
          {
            !isNilOrEmpty(profileImageUrl) ?
              <Avatar
                backgroundColor="#ffffff"
                src={profileImageUrl}
                size={25}
              /> : <Avatar size={25}>{R.head(companyName)}</Avatar>
          }
        </div>
        <div style={{ marginLeft: '10px', width: '97%' }}>
          <textarea
            style={{ resize: 'none', border: '1px solid rgb(202,202,202)', width: '97%', borderRadius: '3px', backgroundColor: '#FFFFFF', minHeight: '35px', maxHeight: '100px' }}
            value={R.equals(commentPostId, postId) ? userEnteredComment : ''}
            onChange={({ target: { value } }) => updateProp({ postComment: { comment: value, postId } })}
            placeholder="Add a comment"
            disabled={updatingPost}
            rows={userEnteredComment ? '' : 1}
            onKeyUp={() => autoExpand()}
            id="newCommentArea"
          />
        </div>
      </div>
      {
        !isNilOrEmpty(userEnteredComment) && commentPostId === postId &&
          <div style={{ display: 'flex', flexDirection: 'row-reverse', marginRight: '25px' }}>
            <FlatButton
              label="SUBMIT"
              secondary
              onTouchTap={() => {
                updateAPost(postId, 'comment', { comment: {
                  comment: userEnteredComment.trim(),
                  profileImageUrl,
                  timestamp: new Date(),
                  companyName,
                  companyId,
                  userName: (isNilOrEmpty(userFirstName) || isNilOrEmpty(userLastName)) ? userEmail : `${userFirstName} ${R.head(userLastName)}`,
                  userId,
                } });
                updateProp({ postComment: { comment: '', postId: '' } });
              }}
              disabled={isNilOrEmpty(userEnteredComment)}
            />
            <FlatButton label="CANCEL" primary onTouchTap={() => updateProp({ postComment: { comment: '', postId: '' } })} />
          </div>
      }
    </div>
  );
};

NewComment.propTypes = {
  profileImageUrl: PropTypes.string,
  companyName: PropTypes.string,
  userEnteredComment: PropTypes.string,
  companyId: PropTypes.string,
  userId: PropTypes.string,
  userFirstName: PropTypes.string,
  userLastName: PropTypes.string,
  userEmail: PropTypes.string,
  updatingPost: PropTypes.bool,
  commentPostId: PropTypes.string,
  updateProp: PropTypes.func,
  postId: PropTypes.string,
  updateAPost: PropTypes.func,
};

const mapStateToProps = ({ newsfeed, user }) => ({
  profileImageUrl: user ? user.getIn(['company', 'profileImageUrl']) : undefined,
  companyName: user ? user.getIn(['company', 'companyName']) : undefined,
  userEnteredComment: newsfeed ? newsfeed.getIn(['postComment', 'comment']) : undefined,
  companyId: user ? user.getIn(['company', 'companyId']) : undefined,
  userId: user ? user.get('id') : undefined,
  userFirstName: user ? user.getIn(['user', 'firstName']) : undefined,
  userLastName: user ? user.getIn(['user', 'lastName']) : undefined,
  userEmail: user ? user.getIn(['user', 'email']) : undefined,
  updatingPost: newsfeed ? newsfeed.get('updatingPost') : undefined,
  commentPostId: newsfeed ? newsfeed.getIn(['postComment', 'postId']) : undefined,
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateProps(...args)),
  updateAPost: (...args) => dispatch(updatePost(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewComment);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/actionBar/newComment.jsx